import type { GridValidRowModel } from "@mui/x-data-grid-premium";
import type { ValidGetListResponse } from "@exonn/base";

type MapRowsResult<Row extends GridValidRowModel = GridValidRowModel> = {
  rows: Row[];
  error?: unknown;
};

export const createMapRowsResult = <
  Row extends GridValidRowModel = GridValidRowModel,
>({
  data,
  mapResourceToRow,
}: {
  data: ValidGetListResponse<Row> | undefined;
  mapResourceToRow?: (data: any) => Row;
}): MapRowsResult<Row> => {
  if (data && mapResourceToRow) {
    try {
      const rows = data.data.map((resource) => ({
        ...mapResourceToRow(resource),
        _resource: resource,
      }));
      return {
        rows,
      };
    } catch (error: unknown) {
      return {
        rows: data.data.map((resource) => ({
          ...resource,
          _resource: resource,
        })), // falling back to raw data
        error,
      };
    }
  }
  if (data) {
    return {
      rows: data.data.map((resource) => ({
        ...resource,
        _resource: resource,
      })),
    };
  }

  return {
    rows: [],
  };
};
